<template>
  <section class="index-ad-flownImg-root">
    <div class="m-ADBox" :style="bgStyle">
      <div class="AD-c" @mouseover="flownApart">
        <div v-if="!showImg" class="lt">
          <div class="lineBox">
            <p class="line animate__animated animate__lightSpeedInLeft animate__delay-1s animate__slow"></p>
            <p class="line line2 animate__animated animate__lightSpeedInLeft animate__delay-1s animate__slow"></p>
          </div>
          <h2 class="h2 animate__bounce animate__animated animate__slow">提供深度定制互联网应用服务</h2>
          <h3 class="h3 animate__rotateInUpLeft animate__animated animate__delay-1s">涵盖企业的互联网品牌传播、数字营销、业务服务支撑等</h3>
          <ul class="btn-ul">
            <li class="btn-li animate__slideInUp animate__animated animate__slow">企业网站开发</li>
            <li class="btn-li animate__slideInUp animate__animated animate__slower">APP定制开发</li>
            <li class="btn-li animate__slideInUp animate__animated animate__delay-1s">微信小程序开发</li>
          </ul>
        </div>
        <img v-if="!showImg" class="ad-img" src="../../assets/bg2.png" alt="">
        <div class="m-luye" id="m-luye">
          <div v-for="(item,index) in bgImg" :key="index" class="luye-li" :style="bgPst(index)"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name       : 'index-ad-flownImg',
  components : {},
  props      : {
    showImg : {
      type    : Boolean,
      default : true,
    },
    imgUrl:{
      type:String,
      default : ''
    }
  },
  data(){
    return {
      bgImg          : [],
      loopFlownApart : true,
    };
  },
  computed   : {
    bgStyle(){
      if(this.imgUrl){
        return {
          'background' : "url(" + this.imgUrl + ")",
          'background-size':'100% 100%',
        }
      }
    }
  },
  beforeMount(){
    this.createKeyframes();
  },
  created(){},
  mounted(){
    setTimeout(() => {
      this.flownApart();
    }, 600)
  },
  methods    : {
    createKeyframes(){
      for (var i = 0; i < 40; i++) {
        this.bgImg.push(i);
      }
    },
    flownApart(loop = false){ // 图片爆破效果
      if (!this.loopFlownApart) {
        return
      }
      this.loopFlownApart = false;
      function rnd(m, n){
        return parseInt(Math.random() * (n - m) + m);
      }
      var oBox = document.getElementById('m-luye');
      var bReady = false;
      var iNow = 0;
      function playAnamet(){
        if (bReady) {return;}
        bReady = true;
        iNow++;
        var aSpan = oBox.children;
        for (var i = 0; i < aSpan.length; i++) {
          //重置初始化
          oBox.style.display = 'flex';
          //执行动画
          aSpan[i].style.transition = '.5s all ease';
          var x = aSpan[i].offsetWidth / 2 + aSpan[i].offsetLeft - oBox.offsetWidth / 2;
          var y = aSpan[i].offsetHeight / 2 + aSpan[i].offsetTop - oBox.offsetHeight / 2;
          aSpan[i].style.transform = 'perspective(800px) translateX(' + x + 'px) translateY(' + y + 'px) rotateX(' + rnd(-180, 180) + 'deg) rotate(' + rnd(-180, 180) + 'deg) scale(1.4)';
          aSpan[i].style.opacity = '0';
        }
        aSpan[0].addEventListener('transitionend', function(){
          bReady = false;
          for (var i = 0; i < aSpan.length; i++) {
            aSpan[i].style.transition = 'none';
            aSpan[i].style.transform = 'perspective(800px) translateX(0) translateY(0) rotateX(0) rotateY(0) scale(1)';
            aSpan[i].style.opacity = 1;
          }
          oBox.style.display = 'none';
        }, false);
      };
      playAnamet();
      setTimeout(() => {
        this.loopFlownApart = true;
      }, 10000)
    },
    bgPst(index){
      var row = parseInt(index / 10),
          x   = -100 * (index % 10) + '%',
          y   = -100 * row + '%';
      if (this.imgUrl) {
        var bgpst = {
          'background': "url(" + this.imgUrl + ")",
          'background-size': "100vw 31vw",
          'background-position' : x + ' ' + y,
        }
        return bgpst;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.index-ad-flownImg-root{
  .m-ADBox{
    height: 31vw; /*根据比例算出*/
    position: relative;
    .ad-img{
      width: 44%;
    }
    .AD-c{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      color: #fff;
      .lineBox{
        .line{
          height: 4Px;
          width: 105px;
          background: #fff;
          margin-bottom: 10px;
        }
        .line2{
          width: 210px;
          margin: 4Px 0;
        }
      }
      .h2{
        font-size: 30px;
        font-weight: normal;
      }
      .h3{
        font-size: 0.2rem;
        font-weight: normal;
      }
      .btn-ul{
        margin-top: 0.1rem;
        display: flex;
        align-items: center;
      }
      .btn-li{
        flex-shrink: 0;
        z-index: 100;
        border-radius: 2em;
        line-height: 2em;
        border: 1Px solid #3c009b;
        padding: 0 1em;
        @extend %btn_base;
        &:not(:first-child){
          margin-left: 1.5em;
        }
      }
    }
    .m-luye{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      width: 100%;
      height: 31vw;
      display: flex;
      flex-wrap: wrap;
      .luye-li{
        width: 10%;
        height: 25%;
        opacity: 1;
        transform: translateX(0px) translateY(0px) skew(0deg);
      }
    }
  }
}
</style>
